const EMOJI_PRESENTATION_REGEX = /[\p{Extended_Pictographic}\uFE0F]/gu;
const ASCII_EMOTICON_REGEX = /(^|\s)(:-?\)|:-?D|:-?\(|:-?O|;-?\)|:\]|:\[|:P|:-P)(?=\s|$|[.!?,])/gi;

export function stripEmojiForSpeech(text: string): string {
  return text
    .replace(EMOJI_PRESENTATION_REGEX, ' ')
    .replace(ASCII_EMOTICON_REGEX, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function getSpeechText(text: string): string {
  const stripped = stripEmojiForSpeech(text);
  return stripped.length > 0 ? stripped : text;
}
